<template>
  <Select v-model="value"
          multiple
          data-title="Usuários"
          data-menu-heading="Usuários"
          data-menu-width="290px"
          :data-button-gradient="true"
          :data-items="users"
          @input="setOperationsFilter"
          @search="searchIds($event)" />
</template>

<script>
    import Select from '@components/Select'

    export default {
        components: {
          Select
        },

        data() {
            return {
              users: [],
              initialUsers: [],
              value: []
            }
        },

        methods: {
          setOperationsFilter(val) {
            this.$store.commit('AUDIT_SET_FILTER', {key: 'loginIds', value: val})
          },
          searchIds(search) {
            this.users = search ? this.initialUsers.filter((user) => {
              return user.label.includes(search);
            }) : this.initialUsers;
          },
        },

        async mounted() {
          const users = await this.$api.audit.listUsers();

          this.initialUsers = users.map((user) => {
            return {
              id: user.id,
              label: user.nome
            }
          }); 
          
          this.users = [...this.initialUsers];
        },
    }
</script>

<style scoped>
</style>
